export default __webpack_public_path__ + "3412ed1dafaf6d8c065a95d1bb6f7534.png";